module.exports = __webpack_public_path__ + "img/ecological_footprint_help_trigger.b24d1d10.jpg";